import React from "react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <>
      <footer className="mkt-footer" data-testid="mkt-footer">
        <div className="mkt-footer-inner">
          <div className="brand-line">
            Crowther. Building the sovereign intelligence stack.
          </div>
          <div className="mkt-footer-cols">
            <div className="mkt-footer-col" data-testid="mkt-footer-col-enterprise">
              <div className="mkt-footer-eyebrow">For People &amp; Enterprises</div>
              <Link to="/enterprise/solution" data-testid="mkt-footer-solution">What We Build</Link>
              <Link to="/enterprise/about" data-testid="mkt-footer-about">About</Link>
              <Link to="/enterprise/research" data-testid="mkt-footer-research">Research</Link>
              <Link to="/enterprise/contact" data-testid="mkt-footer-contact">Contact Us</Link>
            </div>
            <div className="mkt-footer-col" data-testid="mkt-footer-col-machines">
              <div className="mkt-footer-eyebrow">For Machines</div>
              <Link to="/machines" data-testid="mkt-footer-machines-home">Overview</Link>
              <a href="/machines#approach" data-testid="mkt-footer-machines-approach">Approach</a>
              <Link to="/machines/contact" data-testid="mkt-footer-machines-contact">Talk to Crowther</Link>
            </div>
            <div className="mkt-footer-col" data-testid="mkt-footer-col-legal">
              <div className="mkt-footer-eyebrow">Company</div>
              <Link to="/terms" data-testid="mkt-footer-terms">Terms of Service</Link>
              <Link to="/privacy" data-testid="mkt-footer-privacy">Privacy Policy</Link>
            </div>
          </div>
        </div>
        <div className="mkt-footer-bottom">
          <span>2026 Crowther. All rights reserved.</span>
          <span>Human Insight, Amplified.</span>
        </div>
      </footer>
    </>
  );
}
